import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';

export const authConfig: AuthConfig = {
  // Issuer: URL of the Identity Provider
  // redirectURI: URL of the SPA to redirect the user to after login
  // clientId: The SPA's id. The SPA is registered with this id at the auth-server
  issuer: environment.instance,
  redirectUri: environment.redirectUri,
  clientId: environment.clientId,



  // Permission Scope
  scope: 'openid profile email',
  responseType: 'code',
  strictDiscoveryDocumentValidation: false,
  showDebugInformation: true,
  checkOrigin: false,
}